/*
 manager api
*/

import axios from '../axios/axios';

export function getRequestToCreateListApi(params) {
  return axios.post('/manager/getRequestToCreateList', params);
}

export function getRequestToCreateKeywordsApi(params) {
  return axios.post('/manager/getRequestToCreateKeywords', params);
}

export function addRequestToCreateKeywordApi(params) {
  return axios.post('/manager/addRequestToCreateKeyword', params);
}

export function removeRequestToCreateKeywordApi(params) {
  return axios.post('/manager/removeRequestToCreateKeyword', params);
}

export function updateRequestToCreateApi(params) {
  return axios.post('/manager/updateRequestToCreate', params);
}

export function closeRequestToCreateApi(params) {
  return axios.post('/manager/closeRequestToCreate', params);
}

export function linkRequestToCreateApi(params) {
  return axios.post('/manager/linkRequestToCreate', params);
}

export function getRequestToCreateApi(params) {
  return axios.post('/manager/getRequestToCreate', params);
}

export function completeRequestToCreateApi(params) {
  return axios.post('/manager/completeRequestToCreate', params);
}

